<template>
  <b-container>

    <div class="row mt-2">
      <div class="col-xl-12">
        <div class="row d-flex justify-content-center">
          <div class="col-sm-2">
            <article class="statistic-box yellow">
              <div class="d-flex flex-column justify-content-center">
                <div class="number">{{total}}</div>
                <div class="caption">
                  <div>Total de tickets</div>
                </div>
              </div>
            </article>
          </div>
          <div class="col-sm-2">
            <article class="statistic-box red">
              <div  class="d-flex flex-column justify-content-center" >
                <div class="number" >{{abiertos}}</div>
                <div class="caption">
                  <div>Tickets abiertos</div>
                </div>
              </div>
            </article>
          </div>
          <div class="col-sm-2">
            <article class="statistic-box green">
              <div  class="d-flex flex-column justify-content-center">
                <div class="number" >{{cerrados}}</div>
                <div class="caption">
                  <div>Tickets cerrados</div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>

    <vtableDashboard 
     
      :fields='fields' 
      :images='images'
      :titulos='titulos'
      :estados='estados'
      @call-attendant="callAttendant"
    >
    </vtableDashboard>

    <!-- modal image -->
    <b-modal :id="imageModal.id" :title="imageModal.title" ref="imageModal" hide-footer>
      <TicketImage :ticketid="item.id" @closeModal="closeImageModal" />
    </b-modal>

   
  </b-container>
</template>

<script>
import Loading from 'vue-loading-overlay'
import {mapActions,mapState,mapMutations} from 'vuex'

import TicketImage from '@/components/tickets/TicketImage'
import vtableDashboard from '@/components/partials/vtableDashboard'

export default {
  name:'ComponenteDashboardTicket',
  components:{
      Loading,TicketImage,vtableDashboard
  }, 
  data:function () {
      return{
        fields:[
                    {key:'id',label:'Id',sortable:false, thClass: 'b-th'},
                    {key:'solicitante',label:'Solicitante',sortable:false, thClass: 'b-th'},
                    {key:'categoria',label:'Categoria',sortable:false, thClass: 'b-th'},
                    {key:'titulo',label:'Título',sortable:false, thClass: 'b-th'},
                    {key:'descripcion',label:'Descripción', thClass: 'b-th'},
                    {key:'estatus',label:'Estado',sortable:false, thClass: 'b-th'},
                    {key:'images',label:'Imagenes', thClass: 'b-th'},
                    {key:'acciones', label:'Acciones', thClass: 'b-th'},
        ],
        item:[], // variable que almacena los datos invidividuales de 1 ticket.
        /**
         * variable que almacena los datos del modal.
         */
        imageModal:{
          id: 'imagen',
          title: '',
        },
        titulos:[],
        estados:[],
      
                    
      }
  },
  mounted(){
    this.init()
  },//mounted
  computed:{
      //variable del state que tiene el id del login.
      ...mapState('login',['id']),
      ...mapState('etiquetas',['categorias','etiquetas']),
      ...mapState('ticket',['isOk','tickets','images','total','abiertos','cerrados']),
  },//computed

  methods:{
    ...mapActions({
      //_tickets: 'ticket/fetchTickets',
      _images: 'ticket/fetchImages',
      _buscarTotalCategorias : 'etiquetas/buscarTotalCategorias',
      _total:'ticket/fetchTicketTotal',
      _abiertos:'ticket/fetchTicketTotalAbierto',
      _cerrados:'ticket/fetchTicketTotalCerrado',
      _activity:'ticket/fetchActivity',
      //metodo para buscar la etiqueta para rellenar el encabezado de la tabla 
      _etiquetas: 'etiquetas/buscarEtiquetas'
      
    }),
    ...mapMutations({
      _setTicket: 'ticket/setTicket'
    }),
    init() {
      /*this._tickets().then(() => {      
        if(this.tickets.length > 0){
          //
        }
      })//then
*/
      this._images()
      this._buscarTotalCategorias()
      this._total()
      this._abiertos()
      this._cerrados()
      // desde aqui se modifica para tener la etiquetas del titulo y los estados
      let payload = {
          'id' : 3  // trae es el listado de maquinas
        }
      this._etiquetas(payload).then(()=>{
        this.titulos = this.etiquetas
      })
      let payload2 = {
          'id' : 2  // trae el listdo de estados
        }
      this._etiquetas(payload2).then(()=>{
        this.estados = this.etiquetas
      })
          
        
    },//init
    /**
    * Metodo que verifica si una orden esta cerrada y deshabilita el boton.
    */
    isDisabled(newVal){
     
      if (newVal.estatus == 0){
        return true
      }
    },//isDisabled

    
    callAttendant(payload){
      this._setTicket(payload.item)
      let id = {
        'id': payload.item.id
      }
      this._activity(id).then(()=>{
        
        this.$router.push('ticketAttendant')
      })
      
    },

    //metodo para agregar imagen al ticket
    callImageModal(item, index, button){
      this.imageModal.title = `Agregar imagen al ticket #: ${item.id}`
      this.item = item

      this.$root.$emit('bv::show::modal', this.imageModal.id, button)
    },
    /*
    *   metodo que cierra el modal
    */
    closeImageModal(){
      this.$refs["imageModal"].hide();
    },

    callActivity(item, index, button){
      this._setTicket(item)
      this.$router.push('ticketActivity')
    },
    
   



  },//methods
}
</script>

<style lang="scss" scoped>
 li {list-style:none}

.statistic-box{
  border-radius: 4px;
  text-align: center;
  color: #fff;
  background: no-repeat 50% 50%;
  background-size: cover;
  margin: 0 0 30px;
}

.statistic-box>div {
    -webkit-border-radius: inherit;
    border-radius: inherit;
    height: 142px;
    //background: url(../img/statistic-box-grid.png) 50% 0;
    background: url('~@/assets/statistic/statistic-box-grid.png');
    background-size: 21px 20px;
    position: relative;
  }

.statistic-box.red {
    background-color: #fa424a;
    background-image: url('~@/assets/statistic/statistic-box-red.png');
}

.statistic-box.green {
    background-color: #46c35f;
    background-image: url('~@/assets/statistic/statistic-box-green.png');
}

.statistic-box.yellow {
    background-color: #fdad2a;
    background-image: url('~@/assets/statistic/statistic-box-yellow.png');
}
</style>